import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { LogoLoader } from './LogoLoader';
const pageOffset = 66 + 90; // Header and footer
export function PageLoader(props) {
    return (_jsx(Box, { sx: {
            width: '100%',
            height: `calc(100dvh - ${pageOffset}px)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }, children: _jsx(LogoLoader, { ...props }) }));
}
